import React from "react";
import { imgUrlData } from "../../urlData";
import "./style.scss";
import config from "../../config/config";

const BlogCardMob = ({ imgSrc, blogDate, blogTitle, blogDesc, onClick }) => {
  const azure_object_url = config.azure_object_url;

  return (
    <div className="mb_blog_card" onClick={onClick ? onClick : ""}>
      <div className="mb_img_wrapper">
        <img src={imgUrlData + imgSrc} />
      </div>
      <div className="mb_blogcard_details">
        <div className="mb_blog_date">{blogDate}</div>
        <div className="mb_blog_title">{blogTitle}</div>
        <div className="mb_blog_synopsis">{blogDesc}</div>
      </div>
    </div>
  );
};

export default BlogCardMob;
